import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverlayModule } from '@angular/cdk/overlay';

import { TooltipDirective } from './directives/tooltip.directive';
import { TooltipComponent } from './components/tooltip/tooltip.component';
import { PortalModule } from '@angular/cdk/portal';

@NgModule({
  imports: [
    CommonModule,
    OverlayModule,
    PortalModule
  ],
  declarations: [
    TooltipDirective,
    TooltipComponent
  ],
  exports: [
    TooltipDirective
  ],
  entryComponents: [
    TooltipComponent
  ]
})
export class McRAITooltipModule { }
